import React from "react";

const CustomDisabledScreen = ({ loading = false }) => {
  if (!loading) return null;
  return (
    <div
      style={{
        position: "absolute",
        height: "100vh",
        width: "100vw",
        backgroundColor: "transparent",
        left: 0,
        zIndex: 999,
        top: 0,
      }}
    />
  );
};

export default CustomDisabledScreen;
